﻿{
  "createAccount": "Skapa konto",
  "subscription": "Prenumeration",
  "oneTimePurchase": "Engångsköp",
  "billingDetails": "Faktureringsuppgifter",
  "paymentDetails": "Betalningsinformation",
  "requestAQuote": "Formulär för begäran från organisationer",
  "reviewOrder": "Granska beställning",
  "thankYouForYourOrder": "Tack för din beställning!",
  "joinTheCommunity": "Gå med i vår community",
  "startTrial": "Starta en testperiod",
  "yourTrialHasEnded": "Din testperiod är slut",
  "taxExempt": "Skattefritt",
  "taxExemptThankYou": "Har laddats upp.",
  "planDetails": "Information om min prenumeration",
  "modifyPlan": "Ändra plan",
  "modifyPaymentDetails": "Ändra betalningsinformation",
  "redirect": "Omdirigerar till Boardmaker",
  "perpetualTrial": "Ladda ner din {{trialLength}} dagars testperiod",
  "perpetualThankYou": "Din mjukvara är klar!",
  "downloads": "Ladda ned Boardmaker",
  "partner": "Hitta en partner",
  "intro": "Välj en Boardmaker-produkt nedan för att ladda ned den senaste versionen för din enhet.",
"systemRequirements": "Systemkrav",
"releaseNotes": "Versionsinformation",
"comparison": "Jämför prenumeration och licens"
}
